// Shows the signed-in user's name and a sign-out button in the app bar.
// Only rendered when auth is enabled (it uses MSAL hooks, so it must live
// inside the MsalProvider).
import { useMsal } from "@azure/msal-react";
import { Box, Typography, Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

export default function UserMenu() {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() || accounts[0];
  const name = account?.name || account?.username || "";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        {name}
      </Typography>
      <Button
        size="small"
        color="inherit"
        startIcon={<LogoutIcon />}
        onClick={() => instance.logoutRedirect()}
      >
        Sign out
      </Button>
    </Box>
  );
}
